import * as Yup from 'yup';

const MUST_SELECT = 'Vous devez sélectionner';

export const QuotationHeaderSchema = Yup.object().shape({
  interventionDate: Yup.date().typeError('La date doit être valide').nullable(),
  modalities: Yup.string().nullable(),
  note: Yup.string().nullable(),
  paymentTermId: Yup.string().required(
    `${MUST_SELECT} une condition de réglement`,
  ),
  paymentMethodId: Yup.string().required(`${MUST_SELECT} un moyen de paiement`),
  validityPeriodId: Yup.string().required(
    `${MUST_SELECT} une durée de validité`,
  ),
});
